export const REPORT_EVENT_LISTENERS_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-loaded", (e) => {
            alert("Report has been loaded !!!");
        });
        /* END: Event Listeners */`;

export const REPORT_EVENT_LISTENER_CHANGED_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-changed", (e) => {
            alert("Report is changed !!!");
        });
        /* END: Event Listeners */`;

export const REPORT_EVENT_LISTENER_DELETED_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-deleted", (e) => {
            alert("Report deleted !!!");
        });
        /* END: Event Listeners */`;

export const REPORT_EVENT_LISTENER_SAVE_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-saved", (e) => {
            alert("Report saved !!!");
        });
        /* END: Event Listeners */`;

export const REPORT_EVENT_LISTENER_READY_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-ready", (e) => {
            alert("Report is ready !!!");
        });
        /* END: Event Listeners */`;


export const REPORT_EVENT_LISTENER_FAILED_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("discovery-report-failed", (e) => {
            alert("Report load failed !!!");
        });
        /* END: Event Listeners */`;